import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { MUTED_TEXT } from '../ballot-initiatives/detail/detailAtoms';
import { outcomeLabel } from './personDisplay';
import type { CandidateData } from './types';

/**
 * A decided campaign, folded away (ELECTION_OUTCOMES_PRD.md §5.13, O10): once a
 * winner is Office-elect or in office, the race, their own words, measure positions
 * and endorsements stay available here — collapsed — so the page reads as what the
 * person is now.
 */
const PastCampaign: React.FC<{ candidate: CandidateData; children: React.ReactNode }> = ({ candidate, children }) => {
  const [open, setOpen] = useState(false);
  const Icon = open ? ChevronDown : ChevronRight;
  return (
    <section className="card" aria-labelledby="person-past-campaign">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls="person-past-campaign-body"
        className="flex w-full items-center justify-between gap-3 text-left"
      >
        <span className="min-w-0">
          <span id="person-past-campaign" className="block text-lg font-semibold text-text-primary dark:text-text-dark-primary">
            {candidate.election_year} campaign
          </span>
          <span className={`text-[13px] ${MUTED_TEXT}`}>
            {(candidate.office_sought ?? '').split(' · ')[0]} · {outcomeLabel(candidate.status)}
          </span>
        </span>
        <Icon className="h-5 w-5 shrink-0 text-text-tertiary dark:text-text-dark-tertiary" aria-hidden />
      </button>
      {open && <div id="person-past-campaign-body" className="mt-5 space-y-5">{children}</div>}
    </section>
  );
};

export default PastCampaign;
